import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import OneApp from './OneApp';
import DesktopApp from './DesktopApp';
import CarPlayApp from './CarPlayApp';
import SearchApp from './SearchApp';
import AdminApp from './AdminApp';
import AdminSuite from './AdminSuite';
import NavApp from './NavApp';
import HoleApp from './HoleApp';
import EighteenApp from './EighteenApp';
import WidgetHost from './WidgetHost';
import BuggyHome from './BuggyHome';
import WeatherScreen from './screens/WeatherScreen';
import { applyBrand } from './lib/brand';
import { isCarPlayHost } from './lib/locationSource';
import './styles.css';

applyBrand();

// The CarPlay window is glance-and-drive only: search and setup stay on the
// phone (this is also exactly what the entitlement request tells Apple). The
// class hides the sheet and re-seats the glance chrome for a short, wide
// screen — see the .carplay-host rules in styles.css.
if (isCarPlayHost()) document.body.classList.add('carplay-host');

// The launcher tile / Android AppWidget loads /widget directly so it never pays
// for the full app shell.
const route = location.pathname.replace(/\/+$/, '');
const isWidget = route === '/widget';
if (isWidget) document.body.classList.add('widget-host');

// The course picker IS the app: the dashboard tile is the product, and this
// only tells it which course to show. The full map lives at /map — that is the
// customer demo and the base for a real CarPlay app if golf ever becomes an
// eligible entitlement category. Nothing is deleted, it is just not the thing
// that opens.
// Auto-detect is the app: the golfer told us the course by driving to it, so
// asking again is a step that can only be got wrong and that nobody performs
// sitting in a buggy. /search keeps the manual picker for when detection is
// wrong or a course is not in the directory; /map keeps the full head-unit app.
const screen = isWidget
  ? <WidgetHost />
  : route === '/buggy'
    ? <BuggyHome />
    : route === '/weather'
      ? <WeatherScreen />
  : route === '/admin/command'
    ? <AdminSuite />
    : route === '/admin'
      ? <AdminApp />
      : route === '/18' || route === '/holes'
        ? <EighteenApp />
      : route === '/hole'
        ? <HoleApp />
        : route === '/map'
          ? <App />
          : route === '/one'
            ? <OneApp />
            : route === '/desktop'
              ? <DesktopApp />
              : route === '/carplay'
                ? <CarPlayApp />
          : route === '/search'
            ? <SearchApp />
            : <NavApp />;

createRoot(document.getElementById('root')!).render(<StrictMode>{screen}</StrictMode>);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
